import React from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import decode from "jwt-decode";
import Unauthorized from "./Unauthorized";
import TrainingLayout from "./web_training/Components/HomeLayout";

// const {id,username,name,exp}= decode(localStorage.getItem('token'));
// console.log(id,username)
const FeedbackProtectedRoute = ({
  component: Component,
  layout: Layout,
  secret,
  ...rest
}) => (
  <AuthConsumer>
    {({ isAuth }) => (
      <Route
        render={(props) =>
          (isAuth || localStorage.getItem("token") !== null) &&
          decode(localStorage.getItem("token")).trainee === "trainee" ? (
            <Layout>
              <Component {...props} />{" "}
            </Layout>
          ) : isAuth || localStorage.getItem("token") !== null ? (
            <TrainingLayout>
              <Unauthorized />
            </TrainingLayout>
          ) : (
            <Redirect to="/trainee-login" />
          )
        }
        {...rest}
      />
    )}
  </AuthConsumer>
);

export default FeedbackProtectedRoute;
